export default ({ enabled, value } = {}, name) => enabled && value === name;
